(() => {
  const ready = (callback) => document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', callback, { once: true })
    : callback();

  ready(() => {
    const modal = document.querySelector('[data-bpc-shipping-modal]');
    const triggerSelector = '[data-bpc-shipping-open]';
    let lastFocusedElement = null;
    const focusableSelector = ['a[href]','button:not([disabled])','input:not([disabled])','select:not([disabled])','textarea:not([disabled])','summary','[tabindex]:not([tabindex="-1"])'].join(',');

    const setTriggerState = (activeTrigger = null) => {
      document.querySelectorAll(triggerSelector).forEach((trigger) => {
        trigger.setAttribute('aria-controls', 'BpcShippingTrustModal');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', String(trigger === activeTrigger));
      });
    };

    const isVisibleFocusTarget = (element) => {
      if (!(element instanceof HTMLElement) || !element.isConnected || element.getClientRects().length === 0) return false;
      if (element.closest('[hidden], [aria-hidden="true"], [inert]')) return false;
      if (element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true') return false;
      const style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden';
    };

    const visibleFallbackTrigger = () => [...document.querySelectorAll(triggerSelector)]
      .find((trigger) => isVisibleFocusTarget(trigger));

    const modalFocusTargets = () => modal
      ? [...modal.querySelectorAll(focusableSelector)].filter((element) => isVisibleFocusTarget(element))
      : [];

    const openModal = (trigger) => {
      if (!modal) return;
      const activeTrigger = trigger instanceof HTMLElement ? trigger : null;
      lastFocusedElement = activeTrigger || document.activeElement;
      setTriggerState(activeTrigger);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bpc-shipping-modal-open');
      modal.querySelector('.bpc-shipping-trust-modal__close')?.focus();
    };

    const closeModal = () => {
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
      document.body.classList.remove('bpc-shipping-modal-open');
      setTriggerState();
      const focusTarget = isVisibleFocusTarget(lastFocusedElement)
        ? lastFocusedElement
        : visibleFallbackTrigger();
      focusTarget?.focus();
      lastFocusedElement = null;
    };

    document.addEventListener('click', (event) => {
      const openTrigger = event.target.closest(triggerSelector);
      if (openTrigger) {
        event.preventDefault();
        openModal(openTrigger);
        return;
      }
      if (event.target.closest('[data-bpc-shipping-close]')) closeModal();
    });

    document.addEventListener('focusin', (event) => {
      if (!modal || modal.getAttribute('aria-hidden') !== 'false' || modal.contains(event.target)) return;
      modalFocusTargets()[0]?.focus();
    });

    document.addEventListener('keydown', (event) => {
      if (!modal || modal.getAttribute('aria-hidden') !== 'false') return;
      if (event.key === 'Escape') {
        closeModal();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = modalFocusTargets();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!modal.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const summaryMarkup = () => `<div class="bpc-cart-order-info" data-bpc-cart-order-info>
      <div class="bpc-cart-order-info__head">
        <strong>Before checkout</strong>
        <button type="button" class="bpc-cart-order-info__details" data-bpc-shipping-open aria-controls="BpcShippingTrustModal" aria-haspopup="dialog" aria-expanded="false">Details</button>
      </div>
      <div class="bpc-cart-order-info__facts">
        <span class="bpc-cart-order-info__fact">Free standard shipping</span>
        <span class="bpc-cart-order-info__fact">Prepared in 2–5 business days</span>
        <span class="bpc-cart-order-info__fact">Destinations confirmed at checkout</span>
      </div>
    </div>`;

    const addCartSummaries = () => {
      const drawerTotals = document.querySelector('.drawer__footer .cart-drawer__footer');
      if (drawerTotals && !drawerTotals.querySelector('[data-bpc-cart-order-info]')) {
        const taxNote = drawerTotals.querySelector('.tax-note');
        if (taxNote) taxNote.insertAdjacentHTML('beforebegin', summaryMarkup());
        else drawerTotals.insertAdjacentHTML('beforeend', summaryMarkup());
      }

      const cartBlocks = document.querySelector('#main-cart-footer .cart__blocks');
      if (cartBlocks && !cartBlocks.querySelector(':scope > [data-bpc-cart-order-info]')) {
        const checkoutCtas = cartBlocks.querySelector(':scope > .cart__ctas');
        if (checkoutCtas) checkoutCtas.insertAdjacentHTML('beforebegin', summaryMarkup());
        else cartBlocks.insertAdjacentHTML('beforeend', summaryMarkup());
      }
    };

    setTriggerState();
    addCartSummaries();
    new MutationObserver(() => addCartSummaries()).observe(document.body, { childList: true, subtree: true });
  });
})();
